export const SubscriptionsActions = {
  SET_SUBSCRIPTIONS: 'SET_SUBSCRIPTIONS',
  GET_SUBSCRIPTIONS: 'GET_SUBSCRIPTIONS',
}
